import { C } from "@bd/content";
import { Bitmap, hex, OUTLINE, shade } from "./bitmap";

export type PetPose = "sit" | "sleep" | "walk";

/** 12×8 studio pets (from the mocks), coloured by breed. */
export function petSprite(breed: string, pose: PetPose = "sit", frame = 0): Bitmap {
  const b = C.breed[breed] ?? C.breed.tabby;
  const c = hex(b.colors[0]);
  const c2 = hex(b.colors[1] ?? b.colors[0]);
  const im = new Bitmap(12, 8);
  if (b.kind === "dog") {
    if (pose === "sleep") {
      im.ellipse(1, 3, 10, 7, c);
      im.ellipse(7, 2, 11, 6, c);
      im.set(9, 4, OUTLINE);
    } else {
      im.box(1, 3, 8, 6, c);
      im.box(7, 1, 10, 4, c);
      im.set(9, 2, OUTLINE);
      im.set(11, 3, OUTLINE);
      const leg = pose === "walk" && frame ? 1 : 0;
      im.set(2 + leg, 7, shade(c, 0.6));
      im.set(7 - leg, 7, shade(c, 0.6));
      im.box(7, 1, 7, 3, shade(c, 0.7));
      if (b.colors.length > 1) im.box(3, 3, 5, 4, c2);
    }
  } else {
    if (pose === "sleep") {
      im.ellipse(1, 3, 10, 7, c);
      im.ellipse(6, 2, 10, 6, c);
      im.set(7, 1, c);
      im.set(9, 1, c);
      im.line(2, 5, 6, 5, shade(c, 0.75));
    } else {
      im.ellipse(1, 3, 9, 7, c);
      im.ellipse(6, 1, 10, 5, c);
      im.set(7, 0, c);
      im.set(9, 0, c);
      im.line(2, 5, 5, 5, shade(c, 0.75));
      if (pose === "walk") im.set(frame ? 2 : 4, 7, shade(c, 0.6));
    }
    if (b.colors.length > 1) im.box(3, 4, 5, 5, c2);
  }
  return im.outlined(OUTLINE);
}
